import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Person from '@/views/t1/Person'
import Assessment from '@/views/t1/Assessment'
import AddPerson from '@/views/t1/Admin/AddPerson'
import EditPerson from '@/views/t1/EditPerson'
import AddAssessment from '@/views/t1/Admin/AddAssessment'
import EditAssessment from '@/views/t1/EditAssessment'
import AddCseit from '@/views/t1/Admin/AddCseit'
import Cseit from '@/views/t1/Admin/Cseit'
import PrintCseit from '@/views/t1/Admin/PrintCseit'
import LaborScreening from '@/views/t1/Admin/LaborScreening'
import PrintLaborScreening from '@/views/t1/Admin/PrintLaborScreening'
import TraffickingScreening from '@/views/t1/Admin/TraffickingScreening'
import PrintTraffickingScreening from '@/views/t1/Admin/PrintTraffickingScreening'
import Statistics from '@/views/t1/Statistics'
import LookerStatistics from '@/views/t1/LookerStatistics'
// import GoogleMaps from '@/views/GoogleMaps'
import Charts from '@/views/Charts'
import Login from '@/views/pages/Login'
import ForgotPassword from '@/views/pages/ForgotPassword'
import ResetPassword from '@/views/pages/ResetPassword'
import PageNotFound from '@/views/pages/PageNotFound'
import Users from '@/views/t1/Admin/Users'
import User from '@/views/t1/Admin/User'
import AddUser from '@/views/t1/Admin/AddUser'
import EditUser from '@/views/t1/Admin/EditUser'
import Organizations from '@/views/t1/Admin/Organizations'
import organizationList from '@/views/t1/Admin/OrganizationList'
import Organization from '@/views/t1/Admin/Organization'
import AddOrganization from '@/views/t1/Admin/AddOrganization'
import EditOrganization from '@/views/t1/Admin/EditOrganization'
import Groups from '@/views/t1/Admin/Groups'
import Group from '@/views/t1/Admin/Group'
import GroupList from '@/views/t1/Admin/GroupList'
import EditGroup from '@/views/t1/Admin/EditGroup'
import AddGroup from '@/views/t1/Admin/AddGroup'
import Logs from '@/views/t1/Admin/Logs'
import Tos from '@/views/t1/Admin/Tos'
import Downloads from '@/views/pages/Downloads'
import GlobalReport from '@/views/t1/GlobalReport'
import ReviewAnnualData from '@/views/t1/ReviewAnnualData'

Vue.use(Router)

/*
 * Simply set this to false and we skip these checks for demo/troubleshooting purposes
 */
const authMeta = {
  auth: true
}

const otherGlobalMeta = {

}

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: '/tos',
          name: 'End User Agreement',
          component: Tos
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        // {
        //   path: 'google-maps',
        //   name: 'Map',
        //   component: GoogleMaps,
        //   meta: {
        //     ...authMeta,
        //     ...otherGlobalMeta
        //   }
        // },
        {
          path: 'screening',
          name: 'Lighthouse Indicators',
          component: Assessment,
          children: [
            {
              path: '/screening/:id',
              name: 'Lighthouse Indicators with ID',
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            }
          ],
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: '/downloads',
          name: 'Downloads',
          component: Downloads,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: '/statistics',
          name: 'Statistics',
          component: Statistics,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: '/globalreport',
          name: 'Global Report',
          component: GlobalReport,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: '/statistics/new',
          name: 'BI Statistics',
          component: LookerStatistics,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        // This needs to be placed above /person/:id so it takes precedence
        {
          path: '/person/add',
          name: 'Add Person',
          component: AddPerson,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'person',
          name: 'Person',
          component: Person,
          redirect: '/dashboard',
          children: [
            {
              path: '/person/:id',
              name: 'Person with ID'
            }
          ],
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'person/:id/edit',
          name: 'Edit Person',
          component: EditPerson,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'person/:id/edit/:tab',
          name: 'Edit Person Supplement',
          component: EditPerson,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'screening/:id/add',
          name: 'Add Lighthouse Indicators',
          component: AddAssessment,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'screening/:id/edit',
          name: 'Edit Lighthouse Indicators',
          component: EditAssessment,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'cseit/:id/add',
          name: 'Add CSE-IT',
          component: AddCseit,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'cseit/:id/view',
          name: 'View CSE-IT',
          component: Cseit,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'cseit/:id/view/:tab',
          name: 'View CSE-IT Score',
          component: Cseit,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'cseit/:id/print',
          name: 'Print CSE-IT',
          component: PrintCseit,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'laborscreening/:id/add',
          name: 'Add Labor Screening',
          component: LaborScreening,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'laborscreening/:id/view/conclusion',
          name: 'View Labor Screening Conclusion',
          component: LaborScreening,
          props: {
            isExisting: true
          },
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'laborscreening/:id/print',
          name: 'Print Labor Screening',
          component: PrintLaborScreening,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'traffickingscreening/:id/add',
          name: 'Add LA Sex Trafficking Screening',
          component: TraffickingScreening,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'traffickingscreening/:id/view/conclusion',
          name: 'View LA Sex Trafficking Screening Conclusion',
          component: TraffickingScreening,
          props: {
            isExisting: true
          },
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'traffickingscreening/:id/print',
          name: 'Print LA Sex Trafficking Screening',
          component: PrintTraffickingScreening,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'reviewannualdata/:year',
          name: 'Review Annual Data',
          component: ReviewAnnualData,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'forgotpassword',
          name: 'ForgotPassword',
          component: ForgotPassword
        },
        {
          path: 'resetPassword/:passwordResetToken',
          name: 'ResetPassword',
          component: ResetPassword
        }
      ]
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    },
    {
      path: '/admin',
      redirect: '/admin/users',
      name: 'Admin',
      component: Full,
      children: [
        {
          path: 'users/add',
          name: 'Add User',
          component: AddUser,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: Users,
          children: [
          ],
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'users/:id',
          name: 'User',
          component: User,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'users/:id/edit',
          name: 'Edit User',
          component: EditUser,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'organizations',
          name: 'Organizations',
          component: organizationList,
          meta: {
            label: '',
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'organizations',
          name: 'Organizations',
          component: Organizations,
          redirect: 'Organizations/add',
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          },
          children: [
            {
              path: 'add',
              name: 'Add Organization',
              component: AddOrganization,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            },
            {
              path: ':id',
              name: 'View Organization',
              component: Organization,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            },
            {
              path: ':id/edit',
              name: 'Edit Organization',
              component: EditOrganization,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            }
          ]
        },
        {
          path: 'groups',
          name: 'Groups',
          component: GroupList,
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          }
        },
        {
          path: 'groups',
          name: 'Groups',
          component: Groups,
          redirect: 'Groups/add',
          meta: {
            ...authMeta,
            ...otherGlobalMeta
          },
          children: [
            {
              path: 'add',
              name: 'Add Group',
              component: AddGroup,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            },
            {
              path: ':id',
              name: 'View Group',
              component: Group,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            },
            {
              path: ':id/edit',
              name: 'Edit Group',
              component: EditGroup,
              meta: {
                ...authMeta,
                ...otherGlobalMeta
              }
            }
          ]
        },
        {
          path: 'logs',
          name: 'Logs',
          component: Logs
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js